import { Check } from "lucide-react";

import { cn } from "~/lib/utils";
import { rootSessionStatusTextClass } from "~/rootSessionStrip";

export const UNSEEN_SETTLE_LABEL = "Finished while you were away";

/**
 * NV5/NV9 — the unseen-settle marker: a second, visually distinct word beside
 * the liveness dot. The dot answers about the work (alive now, most urgent);
 * the check answers about the person (something settled here after you last
 * stood in this World). Same quiet law as the dot — absent unless it has
 * something to say — and never on the door the person is standing in:
 * entering stamps the seen cursor, so a look is what clears it. One shared
 * component wears the word on every door surface (the rail's doors and the
 * switcher's rows), so there is never a re-drawn second species of it.
 */
export function DoorUnseenSettleMark({ marked }: { readonly marked: boolean }) {
  if (!marked) return null;
  return (
    <>
      <Check
        aria-hidden="true"
        className={cn(
          "size-3 shrink-0 forced-colors:text-[ButtonText]",
          rootSessionStatusTextClass("done"),
        )}
        data-door-unseen-settle=""
      />
      <span className="sr-only">, {UNSEEN_SETTLE_LABEL}</span>
    </>
  );
}
